import { get } from "./api";

export const getGrowthPlanData = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/growthplan/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getResourcePerformance = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/resourceperformanceview/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

export const getPlValues = (id, formattedDate, signal, params={}) => {
  const url = `/api/v2/customers/${id}/plvalues/${formattedDate}/`;
  return get(url, params, false, signal, true);
};

